<template>
  <div class="tendermint-gas-options">
    <div class="d-flex">
      <div
        :class="[
          'option flex-1 d-flex align-center justify-center',
          { selected: item.text === selectedOption.text },
        ]"
        v-for="item in options"
        :key="item.text"
        @click="selectedOption = item"
      >
        <div class="text-center px-4">
          <div class="text-4 line-height-25">{{ item.text }}</div>
          <div class="mt-1 text-6 gray--text" v-if="item.wait">
            {{ item.wait }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-end mt-10" v-if="selectedOption.isAdvance">
      <div class="mr-6">
        <div class="text-5">Gas</div>
        <v-text-field
          :value="value.gas"
          type="number"
          outlined
          single-line
          class="c-input input-gas mt-2"
          placeholder="0"
          hide-details="auto"
          @input="v => updateForm('gas', v)"
        ></v-text-field>
      </div>
      <div>
        <div class="text-5">Fee</div>
        <v-text-field
          :value="value.gasPrice"
          type="number"
          outlined
          single-line
          class="c-input input-gas mt-2"
          placeholder="0"
          hide-details="auto"
          @input="v => updateForm('gasPrice', v)"
          :suffix="currentProject.staking.token.toUpperCase()"
        ></v-text-field>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
export default {
  props: {
    gas: Number,
    value: Object,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
    }),
    options() {
      return [
        {
          text: "Low",
          wait: "30 seconds",
          gasPrice: new BN(this.currentProject.staking.gasPriceStep.slow)
            .multipliedBy(this.gas)
            .div(this.currentProject.staking.conversionRate)
            .toFixed(
              Math.log10(this.currentProject.staking.conversionRate),
              BN.ROUND_CEIL
            ),
        },
        {
          text: "Average",
          wait: "20 seconds",
          gasPrice: new BN(this.currentProject.staking.gasPriceStep.medium)
            .multipliedBy(this.gas)
            .div(this.currentProject.staking.conversionRate)
            .toFixed(
              Math.log10(this.currentProject.staking.conversionRate),
              BN.ROUND_CEIL
            ),
        },
        {
          text: "High",
          wait: "10 seconds",
          gasPrice: new BN(this.currentProject.staking.gasPriceStep.fast)
            .multipliedBy(this.gas)
            .div(this.currentProject.staking.conversionRate)
            .toFixed(
              Math.log10(this.currentProject.staking.conversionRate),
              BN.ROUND_CEIL
            ),
        },
        {
          text: "Advance",
          wait: "Custom",
          isAdvance: true,
        },
      ];
    },
  },
  data: () => ({
    selectedOption: {},
  }),
  methods: {
    updateForm(key, value) {
      this.$emit("input", {
        ...this.value,
        [key]: value,
      });
    },
  },
  mounted() {
    this.selectedOption = this.options[1];
  },
  watch: {
    options() {
      if (!this.selectedOption.isAdvance) {
        this.selectedOption = this.options.find(
          item => item.text === this.selectedOption.text
        );
      }
    },
    selectedOption: {
      immediate: true,
      handler(opt) {
        this.$emit("input", {
          gas: this.value.gas || this.gas,
          gasPrice: new BN(opt.gasPrice || this.value.gasPrice).toFixed(
            Math.log10(this.currentProject.staking.conversionRate),
            BN.ROUND_CEIL
          ),
        });
      },
    },
    gas(val) {
      this.updateForm("gas", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.tendermint-gas-options {
  .option {
    height: 70px;
    border: 1px solid #f2f2f2;
    border-radius: 50px;
    &:not(:first-child) {
      margin-left: 16px;
    }
    &.selected {
      border-color: var(--purple);
      background: rgba(233, 235, 255, 0.15);
    }
    &:not(.selected) {
      opacity: 0.5;
      mix-blend-mode: luminosity;
      &:hover {
        opacity: 1;
        mix-blend-mode: normal;
        border-color: var(--purple);
        background-color: #e9ebff;
        cursor: pointer;
      }
    }
  }
}
</style>
